import FetchPostDataNoAuthNEW from "../services/FetchPostDataNoAuthNEW";

export default async function MailSuggestion(body) {

  var url = "/notification/suggestion_form";

  var data = await FetchPostDataNoAuthNEW(url, body)

  return data;
}
